import { render, staticRenderFns } from "./examineMore.vue?vue&type=template&id=ff7e7c98&scoped=true&"
import script from "./examineMore.vue?vue&type=script&lang=js&"
export * from "./examineMore.vue?vue&type=script&lang=js&"
import style0 from "./examineMore.vue?vue&type=style&index=0&id=ff7e7c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7e7c98",
  null
  
)

export default component.exports